/* eslint-disable max-lines */
import { DialogTitle, Fade } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Grid from '@material-ui/core/Grid/Grid';
import DivLoader from 'components/Shared/DivLoader';
import Snackbar from 'components/Shared/Snackbar';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { WithStyles } from 'decorators/withStyles';
import { enPreviewMode } from 'interfaces/previewMode';
import { ITheme } from 'interfaces/theme';
import React, { PureComponent } from 'react';
import rxjsOperators from 'rxjs-operators';
import themeCustomizerService from 'services/themeCustomizer';
import { themeService } from 'services/themeService';
import { CDN_URL } from 'settings';

interface IState {
  opened: boolean;
  previewMode: enPreviewMode;
  dialogContext: string;
  dialogTitle: string;
  typeAction: string;
}

interface IProps {
  selectedTheme?: ITheme;
  classes?: any;
  isChangingTheme?: boolean;
  onClose: () => void;
}

@WithStyles(theme => ({
  preview: {
    width: 86,
    height: 36,
    border: '1px solid',
    borderRadius: 3
  },
  previewMode: {
    display: 'flex',
    cursor: 'pointer'
  },
  previewModeOption: {
    padding: '4px 8px',
    border: '1px solid #596375',
    fill: '#596375',
    textAlign: 'center',
    width: 65,
    '& svg': {
      width: 25,
      height: 25
    },
    '&:hover': {
      backgroundColor: '#ccc'
    }
  },
  previewModeOptionFirst: {
    borderRadius: '4px 0 0 4px'
  },
  previewModeOptionSecond: {
    borderRadius: '0 4px 4px 0'
  },
  previewModeOptionSelected: {
    backgroundColor: '#596375',
    fill: '#FFF',
    '&:hover': {
      backgroundColor: '#596375'
    }
  },
  gridContainer: {
    height: '100%'
  },
  themeContainerMobile: {
    textAlign: 'center',
    marginTop: 15,
    '& svg': {
      width: 195,
      position: 'absolute'
    }
  },

  themeContainerDesktop: {
    textAlign: 'center',
    marginTop: 15,
    '& svg': {
      width: 380,
      position: 'absolute',
      top: 22,
      left: 0
    }
  },
  themeContent: {
    width: 275,
    top: 45,
    left: 53,
    height: 160,
    position: 'absolute',
    backgroundColor: '#ccc'
  },
  themeContentMobile: {
    width: 165,
    backgroundColor: '#ccc',
    position: 'absolute',
    top: 53,
    height: 294,
    overflow: 'hidden',
    '& img': {
      width: '100%'
    }
  },
  spanOptions: {
    fontWeight: 'bold',
    color: '#596375',
    fontSize: '16px'
  },
  btnDelete: {
    padding: '12px 24px',
    fontWeight: 'bold',
    width: '100%',
    color: '#DC3F53',
    transition: 'all 0.3s ease-in-out',
    borderColor: '#DC3F53',
    '&:hover': {
      color: '#FFF',
      backgroundColor: '#DC3F53'
    }
  },
  btnDuplicate: {
    padding: '12px 24px',
    fontWeight: 'bold',
    width: '100%',
    transition: 'all 0.3s ease-in-out',
    color: theme.variables.colors['primaryColor'],
    borderColor: theme.variables.colors['primaryColor']
  },
  btnEdit: {
    padding: '12px 24px',
    fontWeight: 'bold',
    width: '100%',
    backgroundColor: theme.variables.colors['primaryColor'],
    color: '#FFF',
    transition: 'all 0.3s ease-in-out',
    borderColor: theme.variables.colors['primaryColor'],
    minHeight: '100%',
    '&:hover': {
      backgroundColor: theme.variables.colors['buttonBackgroundHover']
    }
  },
  spanPreview: {
    fontWeight: 'bold',
    color: '#596375',
    fontSize: '14px',
    margin: '5px 0'
  },
  contentPreview: {
    padding: '0px 0 24px 0'
  },
  btnCancel: {
    border: 'solid 1px #5c5f75',
    color: '#6c6f84',
    margin: '0 16px',
    fontWeight: 'bold'
  },
  btnConfirm: {
    color: '#FFF',
    backgroundColor: '#009f56',
    margin: '0 16px',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: '#027741'
    }
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'center',
    '& > h2': {
      fontSize: 24,
      letterSpacing: 0.5
    }
  },
  dialogActionsButtons: {
    display: 'flex',
    justifyContent: 'center',
    padding: '0 0 24px 0'
  },
  imgPreviewDesktop: {
    display: 'flex',
    height: 250,
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  },
  imgPreviewMobile: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    height: 405
  }
}))
export default class Preview extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      opened: false,
      previewMode: enPreviewMode.DESKTOP,
      dialogContext: '',
      dialogTitle: '',
      typeAction: null
    };
  }

  handleChangePreviewMode = (previewMode: enPreviewMode) => {
    this.setState({ previewMode });
  };

  clickOpenDialog = (typeAction: string) => {
    this.setState({ opened: true, typeAction });
    switch (typeAction) {
      case 'duplicate':
        {
          this.setState({ dialogContext: 'Deseja realmente duplicar este tema?' });
          this.setState({
            dialogContext:
              'Ao duplicar este tema, um novo tema será adicionado com as mesmas configurações do tema selecionado',
            dialogTitle: 'Deseja realmente duplicar este tema?'
          });
        }
        break;
      case 'delete': {
        this.setState({
          dialogContext: 'Se excluir este template, ele não poderá mais ser visualizado',
          dialogTitle: 'Deseja realmente excluir este tema?'
        });
      }
    }
  };

  clickCloseDialog = (confirmed: boolean) => {
    if (!confirmed) {
      this.setState({ opened: false });
      return;
    }

    switch (this.state.typeAction) {
      case 'duplicate':
        {
          this.duplicateTheme(this.props.selectedTheme.id);
        }
        break;
      case 'delete': {
        this.deleteTheme(this.props.selectedTheme.id);
      }
    }
  };

  editTheme = () => {
    themeCustomizerService.setTheme(themeCustomizerService.normalizeThemeId(this.props.selectedTheme.type));
    themeCustomizerService.init();
    themeCustomizerService.setData({ themeName: this.props.selectedTheme.name });
    themeCustomizerService.editTheme(this.props.selectedTheme.config);
    themeCustomizerService.openCustomizer();
  };

  deleteTheme = (id: string) => {
    const { onClose } = this.props;
    this.setState({ opened: false });
    themeService
      .deleteTheme(id)
      .pipe(rxjsOperators.loader(), rxjsOperators.bindComponent(this))
      .subscribe(
        () => {
          Snackbar.show('Tema excluído com sucesso!');
          onClose();
        },
        (err: any) => Snackbar.error(err)
      );
  };
  duplicateTheme = (id: string) => {
    const { onClose } = this.props;
    this.setState({ opened: false });
    themeService
      .duplicateTheme(id)
      .pipe(rxjsOperators.loader(), rxjsOperators.bindComponent(this))
      .subscribe(
        () => {
          Snackbar.show('Tema duplicado com sucesso!');
          onClose();
        },
        (err: any) => Snackbar.error(err)
      );
  };

  render() {
    const { classes, selectedTheme, isChangingTheme } = this.props;
    const { previewMode, dialogContext, dialogTitle } = this.state;
    return (
      <div className={classes.contentPreview}>
        <p className={classes.spanPreview}>Pré visualizar</p>
        <div className={classes.previewMode}>
          {/* tslint:disable-next-line:max-line-length */}
          <div
            onClick={this.handleChangePreviewMode.bind(this, enPreviewMode.DESKTOP)}
            className={`${classes.previewModeOption} ${classes.previewModeOptionFirst} ${
              previewMode === enPreviewMode.DESKTOP ? classes.previewModeOptionSelected : ''
            }`}
          >
            <SvgIcon name="desktop" />
          </div>
          {/* tslint:disable-next-line:max-line-length */}
          <div
            onClick={this.handleChangePreviewMode.bind(this, enPreviewMode.MOBILE)}
            className={`${classes.previewModeOption} ${classes.previewModeOptionSecond} ${
              previewMode === enPreviewMode.MOBILE ? classes.previewModeOptionSelected : ''
            }`}
          >
            <SvgIcon name="mobile" />
          </div>
        </div>

        <div
          className={previewMode == enPreviewMode.MOBILE ? classes.themeContainerMobile : classes.themeContainerDesktop}
        >
          {previewMode == enPreviewMode.DESKTOP ? (
            <Fade in={!isChangingTheme}>
              <div className={classes.imgPreviewDesktop}>
                <SvgIcon name="desktopBackGround" />
                <img className={classes.themeContent} src={`${CDN_URL}${selectedTheme.imgDesktop}`} />
              </div>
            </Fade>
          ) : previewMode == enPreviewMode.MOBILE ? (
            <Fade in={!isChangingTheme}>
              <div className={classes.imgPreviewMobile}>
                <SvgIcon name="smartPhoneBackGround" />
                <div className={classes.themeContentMobile}>
                  <img src={`${CDN_URL}${selectedTheme.imgMobile}`} />
                </div>
              </div>
            </Fade>
          ) : (
            <DivLoader width={'100%'} height={'200px'} />
          )}
        </div>

        <div className={classes.themeOptions}>
          <p className={classes.spanOptions}>Opções do tema</p>
          <Grid container justify={'space-between'}>
            <Grid>
              <Button onClick={this.editTheme} classes={{ root: classes.btnEdit }}>
                Editar
              </Button>
            </Grid>
            <Grid>
              <Button
                onClick={this.clickOpenDialog.bind(this, 'duplicate')}
                classes={{ root: classes.btnDuplicate }}
                variant="outlined"
              >
                Duplicar
              </Button>
            </Grid>
            <Grid>
              <Button
                onClick={this.clickOpenDialog.bind(this, 'delete')}
                classes={{ root: classes.btnDelete }}
                variant="outlined"
              >
                Excluir
              </Button>
            </Grid>
          </Grid>
        </div>
        {/* <Campaigns /> */}

        <Dialog
          open={this.state.opened}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" classes={{ root: classes.dialogTitle }}>
            {dialogTitle}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">{dialogContext}</DialogContentText>
          </DialogContent>
          <DialogActions classes={{ root: classes.dialogActionsButtons }}>
            <Button
              onClick={this.clickCloseDialog.bind(this, false)}
              color="primary"
              classes={{ root: classes.btnCancel }}
            >
              Cancelar
            </Button>
            <Button
              onClick={this.clickCloseDialog.bind(this, true)}
              color="primary"
              classes={{ root: classes.btnConfirm }}
            >
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
